import { render, staticRenderFns } from "./settle-info.vue?vue&type=template&id=04e7479e"
import script from "./settle-info.vue?vue&type=script&lang=js"
export * from "./settle-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports